import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const RegistrationPending = () => {
  const { registrationStatus } = useSelector((state) => state.auth);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
          <div className="mb-8">
            <svg
              className="mx-auto h-12 w-12 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Registration Pending
          </h2>
          <p className="text-gray-600 mb-8">
            Thank you for registering with SwarnBhandar. Your application is being reviewed by our team.
            We will notify you via email once your account is approved.
          </p>
          <div className="space-y-4">
            <p className="text-sm text-gray-500">
              Expected review time: 24-48 hours
            </p>
            <Link
              to="/"
              className="inline-block bg-yellow-600 text-white px-6 py-2 rounded-full hover:bg-yellow-700 transition-colors duration-200"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPending; 